var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoHamburger(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16732 5.83341H15.834C16.334 5.83341 16.6673 5.50008 16.6673 5.00008C16.6673 4.50008 16.334 4.16675 15.834 4.16675H4.16732C3.66732 4.16675 3.33398 4.50008 3.33398 5.00008C3.33398 5.50008 3.66732 5.83341 4.16732 5.83341Z",
    fill: "#3D4744"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16732 10.8334H15.834C16.334 10.8334 16.6673 10.5001 16.6673 10.0001C16.6673 9.50008 16.334 9.16675 15.834 9.16675H4.16732C3.66732 9.16675 3.33398 9.50008 3.33398 10.0001C3.33398 10.5001 3.66732 10.8334 4.16732 10.8334Z",
    fill: "#F3859B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16732 15.8334H15.834C16.334 15.8334 16.6673 15.5001 16.6673 15.0001C16.6673 14.5001 16.334 14.1667 15.834 14.1667H4.16732C3.66732 14.1667 3.33398 14.5001 3.33398 15.0001C3.33398 15.5001 3.66732 15.8334 4.16732 15.8334Z",
    fill: "#3D4744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoHamburger);
export default __webpack_public_path__ + "static/media/ico_hamburger.4fa2008251f23ca344db94a9929e9c78.svg";
export { ForwardRef as ReactComponent };